var $1b8da20507600032$exports = {};
/* Master JS file — no dependencies. */ const $1b8da20507600032$var$header = document.getElementById('site-header');
const $1b8da20507600032$var$nav = document.getElementById('nav');
const $1b8da20507600032$var$navToggle = document.getElementById('nav-toggle');
const $1b8da20507600032$var$navLinks = [
    ...document.querySelectorAll('.nav__list a')
];
const $1b8da20507600032$var$prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
/* --- Mobile navigation -------------------------------------------------- */ const $1b8da20507600032$var$setNavOpen = (open)=>{
    $1b8da20507600032$var$nav.classList.toggle('is-open', open);
    $1b8da20507600032$var$navToggle.setAttribute('aria-expanded', String(open));
    $1b8da20507600032$var$navToggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
};
$1b8da20507600032$var$navToggle.addEventListener('click', ()=>{
    $1b8da20507600032$var$setNavOpen(!$1b8da20507600032$var$nav.classList.contains('is-open'));
});
$1b8da20507600032$var$nav.addEventListener('click', (event)=>{
    if (event.target.closest('a')) $1b8da20507600032$var$setNavOpen(false);
});
document.addEventListener('keydown', (event)=>{
    if (event.key === 'Escape' && $1b8da20507600032$var$nav.classList.contains('is-open')) {
        $1b8da20507600032$var$setNavOpen(false);
        $1b8da20507600032$var$navToggle.focus();
    }
});
document.addEventListener('click', (event)=>{
    if (!$1b8da20507600032$var$nav.classList.contains('is-open')) return;
    if (!$1b8da20507600032$var$nav.contains(event.target) && !$1b8da20507600032$var$navToggle.contains(event.target)) $1b8da20507600032$var$setNavOpen(false);
});
/* --- Header state ------------------------------------------------------- */ const $1b8da20507600032$var$updateHeader = ()=>{
    $1b8da20507600032$var$header.classList.toggle('is-scrolled', window.scrollY > 40);
};
$1b8da20507600032$var$updateHeader();
window.addEventListener('scroll', $1b8da20507600032$var$updateHeader, {
    passive: true
});
/* --- Scroll reveal ------------------------------------------------------ */ const $1b8da20507600032$var$revealables = [
    ...document.querySelectorAll('[data-reveal]')
];
if ($1b8da20507600032$var$prefersReducedMotion.matches || !('IntersectionObserver' in window)) $1b8da20507600032$var$revealables.forEach((el)=>el.classList.add('is-visible'));
else {
    const revealObserver = new IntersectionObserver((entries, observer)=>{
        entries.filter((entry)=>entry.isIntersecting).forEach((entry, index)=>{
            // Stagger items that come into view together.
            entry.target.style.setProperty('--reveal-delay', `${index * 70}ms`);
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.05
    });
    $1b8da20507600032$var$revealables.forEach((el)=>revealObserver.observe(el));
}
/* --- Active section in the nav ------------------------------------------ */ const $1b8da20507600032$var$sections = $1b8da20507600032$var$navLinks.map((link)=>document.querySelector(link.getAttribute('href'))).filter(Boolean);
if ('IntersectionObserver' in window && $1b8da20507600032$var$sections.length) {
    const setActive = (id)=>{
        $1b8da20507600032$var$navLinks.forEach((link)=>{
            link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
        });
    };
    const spyObserver = new IntersectionObserver((entries)=>{
        const visible = entries.filter((entry)=>entry.isIntersecting).sort((a, b)=>b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
    }, {
        rootMargin: '-20% 0px -70% 0px',
        threshold: [
            0,
            0.25,
            0.5
        ]
    });
    $1b8da20507600032$var$sections.forEach((section)=>spyObserver.observe(section));
}
/* --- Age ---------------------------------------------------------------- */ /* Keeps the "j'ai N ans" sentence from going stale. Set the real date in the
   data-birthdate attribute in index.html. */ const $1b8da20507600032$var$ageEl = document.querySelector('[data-age]');
if ($1b8da20507600032$var$ageEl?.dataset.birthdate) {
    const birth = new Date($1b8da20507600032$var$ageEl.dataset.birthdate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDelta = today.getMonth() - birth.getMonth();
    if (monthDelta < 0 || monthDelta === 0 && today.getDate() < birth.getDate()) age -= 1;
    if (Number.isFinite(age) && age > 0) $1b8da20507600032$var$ageEl.textContent = String(age);
}


//# sourceMappingURL=index.290ba629.js.map
